import antdRU from 'ant-design-vue/es/locale-provider/ru_RU';
import dayjsLocale from 'dayjs/locale/ru';
import momentRU from 'moment/dist/locale/ru';
import data from '../json/ru.json';

const components = {
  antLocale: antdRU,
  momentName: 'ru',
  momentLocale: momentRU,
  dayjsName: 'ru',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
